import { configureStore, combineReducers } from '@reduxjs/toolkit'
import heartDataReducer from 'redux/reducers/heartDataReducer'
import patientReducer from 'redux/reducers/selectedPatientReducer'
import weightReducer from 'redux/reducers/weightReducer'
import stepsReducer from 'redux/reducers/stepsReducer'
import caloriesReducer from 'redux/reducers/caloriesReducer'
import notesReducer from 'redux/reducers/notesReducer'
import allPatientsReducer from 'redux/reducers/allPatientsReducer'
import selectedCenterReducer from 'redux/reducers/selectedCenterReducer'
import formsReducer from 'redux/reducers/configFormsReducer'
import allProfessionalsReducer from 'redux/reducers/allProfessionalsReducer'
import messagesReducer from 'redux/reducers/messagesReducer'
import contentReducer from 'redux/reducers/contentReducer'
import patientContentReducer from 'redux/reducers/patientContentReducer'
import notificationReducer from 'redux/reducers/notificationReducer'
import centersReducer from 'redux/reducers/centersReducer'
import studyReducer from 'redux/reducers/studyReducer'
import studyFormAnswersReducer from 'redux/reducers/studyFormAnswersReducer'
import selectedFormReducer from 'redux/reducers/selectedFormReducer'
import alertsReducer from 'redux/reducers/alertsReducer'
import studyFormAnswersExportsReducer from 'redux/reducers/studyFormAnswersExportsReducer'
import dataAppAndPackageReducer from 'redux/reducers/dataAppAndPackageReducer'
import cacheReducer from 'redux/reducers/cacheReducer'
import userAuthenticationReducer from 'redux/reducers/userAuthenticationReducer'
import reduxMiddleware from 'redux/middleware'
import packagesReducer from 'redux/reducers/packagesReducer'
import wizardsReducer from 'redux/reducers/wizardsReducer'
import scheduledFormsReducer from 'redux/reducers/scheduledFormsReducer'
import organizationsReducer from 'redux/reducers/organizationsReducer'
import patientFormsReducer from 'redux/reducers/patientFormsReducer'
import patientReportReducer from 'redux/reducers/patientReportReducer'
import patientScoreReducer from 'redux/reducers/patientScoreReducer'

const combinedReducer = combineReducers({
  userAuthentication: userAuthenticationReducer,
  allPatients: allPatientsReducer,
  allProfessionals: allProfessionalsReducer,
  patient: patientReducer,
  heartData: heartDataReducer,
  weightData: weightReducer,
  stepsData: stepsReducer,
  caloriesData: caloriesReducer,
  notes: notesReducer,
  formsConfig: formsReducer,
  messages: messagesReducer,
  content: contentReducer,
  patientContent: patientContentReducer,
  notification: notificationReducer,
  center: selectedCenterReducer,
  centers: centersReducer,
  study: studyReducer,
  studyFormAnswers: studyFormAnswersReducer,
  selectedForm: selectedFormReducer,
  alerts: alertsReducer,
  formAnswersExport: studyFormAnswersExportsReducer,
  optionsAppAndBusiness: dataAppAndPackageReducer,
  cache: cacheReducer,
  businessPackage: packagesReducer,
  formsByPatient: patientFormsReducer,
  reportsByPatient: patientReportReducer,
  scoresByPatient: patientScoreReducer,
  scheduledForm: scheduledFormsReducer,
  wizards: wizardsReducer,
  organizations: organizationsReducer
});

// ** rootReducer is used to reset the store state every time a new patient is selected, see: https://stackoverflow.com/questions/59061161/how-to-reset-state-of-redux-store-when-using-configurestore-from-reduxjs-toolki
const rootReducer = (state, action) => {
  if (action.type === "userAuthentication/logout") {
    state = undefined
  }

  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), reduxMiddleware()],
})

export default store